import { X } from "lucide-react";
import { NativeSelect } from "@/components/Common";
import { STATES } from "@/components/profile/options";

const NAME = Object.fromEntries(STATES);

export const StatesInput = ({ value = [], onChange }) => (
  <div className="space-y-2">
    <div className="flex flex-wrap gap-2" data-testid="states-list">
      {value.map((s) => (
        <span key={s} className="inline-flex items-center gap-1 rounded-full border border-[#D4AF37]/30 bg-[#D4AF37]/10 px-3 py-1 text-xs text-[#F3C649]">
          {NAME[s] || s}
          <button type="button" onClick={() => onChange(value.filter((x) => x !== s))} data-testid={`remove-state-${s}`}><X className="h-3 w-3" /></button>
        </span>
      ))}
    </div>
    <NativeSelect value="" onChange={(v) => v && !value.includes(v) && onChange([...value, v])} className="w-full" data-testid="states-select"
      options={[{ value: "", label: "Add a state..." }, ...STATES.filter(([c]) => !value.includes(c)).map(([c, n]) => ({ value: c, label: n }))]} />
  </div>
);
